import React from 'react';
import { DetailInfo, U } from '../../../../assets/img/svg/details';
import { Check } from '../../../../assets/img/svg/icons';

const Card: React.FC<{ text: string }> = ({ text }) => {
    return (
        <div className="bg-white rounded-xl flex flex-col items-center justify-center gap-2 p-8 drop-shadow-sm relative">
            <div className="h-8 w-8 mx-auto flex items-center justify-center">
                <Check className='w-2/3 h-2/3 object-contain' />
            </div>

            <div className="text-sm text-center text-balance" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
};  

const InfoSection: React.FC<{}> = () => {
    return (
        <section className='pt-8 pb-14 max-w-[1920px] mx-auto relative z-20'>
            <U className='absolute left-1/2 md:-left-[200px] -translate-x-1/2 md:translate-x-0 bottom-1/2 translate-y-1/2 md:translate-y-2/3 -z-10 rotate-[20deg] w-[300px] md:w-[500px] h-[300px] md:h-[500px] object-contain pointer-events-none' />
            <div className="absolute left-1/2 -translate-x-1/2 -z-20 top-20 h-[calc(100%+200px)] w-dvw">
                <DetailInfo className='object-cover h-full w-full scale-150 -translate-y-44 pointer-events-none' />
            </div>

            <h3 className="text-2xl text-center font-semibold">
                Conheça os benefícios em participar:
            </h3>

            <div className="mt-12 grid md:grid-cols-3 lg:grid-cols-5 gap-2">
                <Card  text="<strong class='block'>Visibilidade</strong> Esteja ao lado das mais renomadas universidades e faculdades, destacando sua instituição no universo educacional." />
                <Card  text="<strong class='block'>Interação direta com os estudantes</strong> Ofereça palestras, workshops e oficinas práticas, criando uma conexão direta com os estudantes." />
                <Card  text="<strong class='block'>Formatos presenciais e virtuais</strong> Amplie sua visibilidade alcançando estudantes de todo o Brasil, com eventos presenciais e online, para diferentes públicos." />
                <Card  text="<strong class='block'>Programação exclusiva para pais e educadores</strong> Fortaleça sua imagem educacional com uma programação voltada para os responsáveis e educadores, gerando mais confiança para sua instituição." />
                <Card  text="<strong class='block'>Leads qualificados</strong> Atraia alunos com perfil alinhado ao seu portfólio acadêmico, gerando contatos para futuras ações de marketing e prospecção." />
            </div>
        </section>
    );
};

export default InfoSection;